<template>
  <report-section title="呼吸资料" style="position: relative">
    <template v-slot:content>
      <div class="sleep-event">
        <el-table :data="tableData" border style="width: 100%" :span-method="arraySpanMethod">
          <!-- 呼吸事件列 -->
          <el-table-column prop="name" label="呼吸事件" width="100" align="center">
            <template slot-scope="scope">
              <span
                :style="{ fontWeight: scope.row.isParent ? 'bold' : 'normal', paddingLeft: scope.row.isChild ? '20px' : '0' }">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>

          <!-- 次数列 -->
          <el-table-column prop="times" label="次数" width="80" align="center" />

          <!-- 呼吸暂停或低通气指数列 -->
          <el-table-column prop="index" label="呼吸暂停或低通气指数" width="140" align="center" />

          <!-- %列 -->
          <el-table-column prop="percentage" label="%" width="60" align="center" />

          <!-- REM期列组 -->
          <el-table-column label="REM期" align="center">
            <el-table-column prop="remTimes" label="REM次数" width="85" align="center" />
            <el-table-column prop="remIndex" label="REM指数" width="85" align="center" />
          </el-table-column>

          <!-- NREM期列组 -->
          <el-table-column label="NREM期" align="center">
            <el-table-column prop="nremTimes" label="NREM次数" width="85" align="center" />
            <el-table-column prop="nremIndex" label="NREM指数" width="85" align="center" />
          </el-table-column>

          <!-- 平均时间列 -->
          <el-table-column prop="averageTime" label="平均时间(秒)" width="100" align="center" />

          <!-- 最长时间列 -->
          <el-table-column prop="longestTime" label="最长时间(秒)" width="100" align="center" />

          <!-- 发生时间列 -->
          <el-table-column prop="occurrenceTime" label="发生时间" width="90" align="center" />
        </el-table>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";

export default {
  data() {
    return {
    }
  },
  computed: {
    tableData() {
      
      return this.model.breathingData
    }
  },
  components: {
    ReportSection,
  },
  props: {
    model: Object,
  },
  methods: {
    // 合并单元格方法
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 只对"最长时间"和"发生时间"列进行合并（现在是第8和第9列）
      // if (columnIndex === 8 || columnIndex === 9) { 
      //   if (rowIndex === 0) {
      //     // 呼吸暂停行，合并4行
      //     return {
      //       rowspan: 4,
      //       colspan: 1
      //     };
      //   } else if (rowIndex >= 1 && rowIndex <= 3) {
      //     // 阻塞型、中枢型、混合型行，隐藏
      //     return {
      //       rowspan: 0,
      //       colspan: 0
      //     };
      //   }
      // }
      // 其他单元格正常显示
      return {
        rowspan: 1,
        colspan: 1
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.sleep-event {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 20px;

  ::v-deep .el-table {
    font-size: 13px;

    th {
      background-color: #f5f7fa;
      font-weight: bold;
      padding: 6px 0;
    }

    td {
      padding: 6px 0;
    }

    .cell {
      padding: 4px 2px;
      line-height: 1.3;
    }
  }
}
</style>